/* eslint-disable react/no-danger */
import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import { setNavDataInGlobalObj } from 'utils/cdpUtils';
import {
  loadLayoutData,
  loadLayoutDataTOIP,
  loadCommonData,
  // loadSidebarData,
} from 'reduxUtils/modules_v2/layout';
import {
  getAtfFanAdCode,
  getFbnFanAdCode,
  setAdsConfig,
  processAdsCaimpaigns,
} from 'helpers/ads/utils';
import { getImageName, createLeadImageUrl } from 'components/Image/utils';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
import generateArticleshowSchema from 'helpers/seo/getArticleshowSchema';
// import AdCaller from 'helpers/ads/adCaller';
import {
  commonHeadScriptsMobile,
  commonHeadScripts,
} from 'helpers/scripts/headScripts';
import { gptHeadAppendScript } from 'helpers/ads/constants';
import { adRecoverScriptString } from 'routes/articleshow/utils/adRecover';
import { setValue } from 'routes/articleshow/utils/ctnTargeting';
import Layout from 'components_v2/desktop/Layout/Layout';
// import LinksList from 'components_v2/desktop/LinksList';
import {
  loadArticleshowData,
  loadArticleshowDataNew,
  loadNewSectionInfo,
  loadExternalWidgetData,
  loadElections,
  loadExitPoll,
  loadAsBreifs,
  updateActiveMsid,
  updateArticleToShowCount,
  updateArticleToShowResetDays,
  // loadCardsInsert,
  loadRelatedArticles,
  getCardData,
  // getBundleCardData,
  getBundleHashtag,
  populateArticleshowWidgets,
  loadBoardResultData,
  // loadCardInsertLiteData,
} from 'routes/articleshow_v2/redux';
import { getWidgetMapping } from 'routes/articleshow_v2/config';
import { getGAData } from 'routes/articleshow/utils/getGAData';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import { getActiveCfmid } from 'reduxUtils/modules_v2/header';
import { setGrxParams } from 'utils/setGrxData';
// import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
// import LayoutPrime from '../../components/LayoutPrime';
import {
  // isTablet,
  // isIOS,
  // getAuthors,
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  setCacheTime,
  isPrimeContent,
  fireGA4Script,
  fireCustomDimension,
  // setViewedArticleMsidsInLocalStorage,
  getSectionForPathName,
  getAuthorsName,
} from 'utils/common';
import WithVideoTheater from '../../components/common/VideoTheater/WithVideoTheater';
import isExperimentEnabled from '../../utils/isExperimentEnabled';
import getGa4PageViewEventObj from '../../utils/getGa4PageViewEventObj';

// import WithNewsInContext from '../../components/common/NewsInContext/WithNewsInContext';
import {
  STAGING_URL_PREFIX2,
  FREE_ARTICLE_PRIME_ID,
  PAID_ARTICLE_PRIME_ID,
  TEMPLATE_NAME_FOR_TOIP_FREE_ARTCILE,
  TEMPLATE_NAME_FOR_TOIP_PAID_ARTCILE,
  AFFILIATES_SDK_URL,
  TOI_LIVE_DOMAIN,
  ARTICLESHOW,
  TOI_INSTAGRAM_EMBED_JS,
  DESKTOP_PLATFORM,
  BUSINESS_TOI,
  WEBVIEW_PLATFORM,
  REVIEWS_LIVE_DOMAIN,
  REVIEWS_LIVE_DOMAIN_WITHOUT_HTTPS,
  REVIEWS_SITE_VERIFICATION_CODE,
  // FORMULAE_PLAYLIST_ID,
  // TIMES_SPECIAL_NOC_NAME,
} from '../../../../constants';
import s from './Articleshow_v2.scss';
import { implementExperiment } from '../../../../utils/primeUtil';
import { TAM_SCRIPT } from '../../../../components/Html/constants';
import {
  getMSPCountryCodeMap,
  getMspBasicPageHrefLang,
  getMspInPageHrefLang,
  getMspUSPageHrefLang,
  getReviewsPageURLFromMspPageURL,
  isRedirectableMspArticle,
} from '../../utils/mspUtils';
// import { loadServerSidePageLevelData } from '../../../../components_v3/PersonalizedLoader/redux';
import { loadElectionData } from '../../../../components/ElectionV2/redux';
// import { loadLokSabhaElectionData } from '../../../../components/ElectionV2/loksabha_redux';
import getCwvReportingObj from '../../../../utils/getCwvReportingObj';

const pageName = 'articleshow_v2_desktop';

async function action(context, params) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const isBrowser = typeof window === 'object';
  const isServer = typeof window === 'undefined';
  const isWapView = false;
  let isPrime = false;
  const { pathname } = context;
  let showMiniTv = true;
  let hideAdCude = false;
  let leadImageHref = '';

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState();
  const isReviewsPage = state.isTOIReviews;

  let primeTemplateChunk = 'toipArticleshowv2desktop_nonprime';
  if (state.isPrime) {
    primeTemplateChunk = 'toipArticleshowv2desktop_prime';
  } else {
    primeTemplateChunk = 'toipArticleshowv2desktop_nonprime';
  }

  const isPromoshow = pathname?.indexOf('promoshow') > -1;
  const isNewFeedEnabled = !isReviewsPage && !isPromoshow;

  let sectionInfo = {};
  let widgetMapping = {};
  if (isNewFeedEnabled) {
    sectionInfo = {
      sectionL1: getSectionForPathName(context.pathname),
      sectionL2: getSectionForPathName(context.pathname, 2),
    };

    widgetMapping = getWidgetMapping(sectionInfo);
  }

  const newParams = {
    ...params,
    // fullPath: context.path,
    fullPath:
      pathname?.indexOf('promoshow') > -1
        ? `/promoshow/${params.msid}.cms`
        : `/articleshow/${params.msid}.cms`,
    isWapView,
    isAppView,
    skipSubSections: false,
    isClientConsumable: context.query.test === 'consumable',
    frmprime: state.isPrime ? 'yes' : '',
    isPrime: state.isPrime,
    isReviewsPage,
    isNewFeedEnabled,
    sectionInfo,
    widgetMapping,
  };
  let showPreload;
  const imageInfo = [];
  const isWorldArticle = context.path && context.path.indexOf('/world/') !== -1;
  const isCityArticle = context.path && context.path.indexOf('/city/') !== -1;
  const isSportsBeaconJs = false;

  if (!state.articleshow_v2.data) {
    if (isNewFeedEnabled) {
      dataPromiseArray.push(
        context.store.dispatch(loadArticleshowDataNew(newParams, isAppView)),
      );
    } else {
      dataPromiseArray.push(
        context.store.dispatch(loadArticleshowData(newParams, isAppView)),
      );
    }
  }

  if (isNewFeedEnabled && !state.articleshow_v2.msidmappingdata) {
    // context.path && context.path.split('/')[1];
    dataPromiseArray.push(
      context.store.dispatch(loadNewSectionInfo(newParams)),
    );
    dataPromiseArray.push(
      context.store.dispatch(loadExternalWidgetData(newParams, isAppView)),
    );
  }
  if (
    !isAppView &&
    (isWorldArticle || isCityArticle) &&
    !state.articleshow_v2.relatedArticles
  ) {
    dataPromiseArray.push(
      context.store.dispatch(loadRelatedArticles(params.msid, true)),
    );
  }

  if (isAppView && !state.sidebar.data) {
    dataPromiseArray.push(
      //passing template name/ resolved routes to feed instead of entire articleshow path
      context.store.dispatch(loadCommonData(newParams, 'articleshow')),
    );
    // dataPromiseArray.push(
    //   //passing template name/ resolved routes to feed instead of entire articleshow path
    //   context.store.dispatch(loadSidebarData(newParams)),
    // );
  } else if (
    !isAppView &&
    (!state.header.data || !state.footer_v2.data || !state.sidebar.data)
  ) {
    dataPromiseArray.push(
      context.store.dispatch(
        loadLayoutData({
          ...newParams,
          fullPath: `/articleshow/${params.msid}.cms`,
        }),
      ),
    );
  }
  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // if (!state.articleshow_v2.cardsInsertsLite) {
  //   dataPromiseArray.push(context.store.dispatch(loadCardInsertLiteData()));
  // }

  // wait for responses on server side
  if (
    typeof window === 'undefined' ||
    (isBrowser && dataPromiseArray.length > 0 && !state.articleshow_v2.data)
  ) {
    await Promise.all(dataPromiseArray);
    context.store.dispatch(updateActiveMsid(params.msid));
    if (isNewFeedEnabled) {
      context.store.dispatch(populateArticleshowWidgets(newParams));
    }
  }
  state = context.store.getState();

  let status = 200;
  let redirect = false;
  let title = 'Get Latest News Updates from The Times Of India';
  let dataAvailable =
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid];
  const primeId = state?.articleshow_v2?.data
    ? state.articleshow_v2.data[params.msid]?.primeid
    : null;
  const storyTitle = state?.articleshow_v2?.data
    ? state.articleshow_v2.data[params?.msid]?.hl
    : '';
  const isImmersive =
    state &&
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    !!state.articleshow_v2.data[params.msid]?.isImmersive;
  const forcedErrorStatus =
    state.articleshow_v2 && state.articleshow_v2.forcedErrorStatus
      ? state.articleshow_v2.forcedErrorStatus
      : null;
  const ispromoarticle =
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid] &&
    (state.articleshow_v2.data[params.msid]?.ispromoarticle ||
      (primeId &&
        state.articleshow_v2.data[params.msid]?.metaInfo?.overridetemplate &&
        state.articleshow_v2.data[params.msid]?.metaInfo?.overridetemplate ===
          'marketinglink'));

  const reviewsSectionList = _get(
    state,
    'common.siteConfig.affiliates.reviewsConfig',
    [],
  );
  const redirectableReviewSection = isRedirectableMspArticle(
    reviewsSectionList,
    context,
  );
  //------------------------------------------------------
  // this is done for maintaing preload image url , on the basis of this , we are adding height=225,
  // as this is same done in LeadImageOrVideo component
  const isAutoPublishedArticle = isCityArticle;
  //------------------------------------------------------
  const isMSP = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    const { isMSPArticle } = articleData;
    const { navsubsecs: { subsec1: { subsecmsid1 } = {} } = {} } = articleData;
    const mspOtherArticles = ['106630271'];
    const mspPathNames = ['most-searched-products', 'hot-picks'];
    const isMspOtherArticles = mspOtherArticles.includes(subsecmsid1);
    let isMspPathName = false;
    // eslint-disable-next-line no-restricted-syntax
    for (const path of mspPathNames) {
      const isActive = pathname.includes(path);
      if (isActive) {
        isMspPathName = isActive;
        break;
      }
    }
    return isMSPArticle || isMspOtherArticles || isMspPathName;
  };

  const isSpotlight = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    const { ag: articleAgencyName } = articleData;
    const { navsubsecs: { subsec2: { subsecmsid2 } = {} } = {} } = articleData;
    return (
      articleAgencyName === 'SPOTLIGHT' ||
      articleAgencyName === 'Spotlight Wire' ||
      subsecmsid2 === '6590699' ||
      subsecmsid2 === '63710536' ||
      params.msid === '108210513'
    );
  };

  const isMspUSArticle = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    const { navsubsecs = {} } = articleData;
    if (Object.keys(navsubsecs).length !== 0) {
      const mspUSPageMsid = _get(navsubsecs, 'subsec2.subsecmsid2');
      return mspUSPageMsid === '103028965';
    }
    if (isBrowser) {
      // eslint-disable-next-line no-shadow
      const { pathname = '' } = window.location || {};
      return pathname.includes('most-searched-products/us/');
    }
    return '';
  };

  const getMSPCountryCode = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    const { navsubsecs = {} } = articleData;

    if (Object.keys(navsubsecs).length !== 0) {
      const sectionMsid = _get(navsubsecs, 'subsec2.subsecmsid2');
      const countryMap = getMSPCountryCodeMap();
      return countryMap[sectionMsid] || '';
    }
    return '';
  };

  const isMSPArticle = isMSP();
  const isSPOTLIGHTArticle = isSpotlight();
  const isMspUSPage = isMspUSArticle();
  const mspCountryCode = getMSPCountryCode();
  let spotlightSpecificAds = false;
  let isAdRestrictedArticle =
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid] &&
    state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID &&
    state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID === 'noad';

  if (isSPOTLIGHTArticle && !isAdRestrictedArticle) {
    isAdRestrictedArticle = true;
    spotlightSpecificAds = true;
  }
  let isInstaEmbeds = false;

  const subtypeKey = isNewFeedEnabled ? 'subType' : 'type';
  const typeKey = isNewFeedEnabled ? 'type' : 'tn';

  const checkInstaEmbeds = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    if (!articleData || !articleData.story) {
      return false;
    }
    const instaEmbeds = articleData.story.filter(
      item => item[typeKey] === 'cdata' && item[subtypeKey] === 'instagram',
    );
    return instaEmbeds && Array.isArray(instaEmbeds) && instaEmbeds.length > 0;
  };

  if (primeId === FREE_ARTICLE_PRIME_ID) {
    return {
      forwardedHeaders: {
        sendToPrimeTemplate: true,
      },
    };
  }

  const IMMERSIVE_PRIME_ARTICLE_USER_NON_PRIME =
    isImmersive && (!primeId || (isPrime && primeId)); //this will be removed in subsequent release of mobile primeshow

  if (
    IMMERSIVE_PRIME_ARTICLE_USER_NON_PRIME ||
    (pathname?.indexOf('promoshow') > -1 && !ispromoarticle)
  ) {
    status = 404;
    dataAvailable = false;
  }
  if (isServer && !dataAvailable) {
    status = 404;
  }
  if (
    state &&
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data.undefined &&
    state.articleshow_v2.data.undefined.redirectUrl
  ) {
    status = 301;
    redirect = state.articleshow_v2.data.undefined.redirectUrl;
  }
  if (forcedErrorStatus) {
    status = forcedErrorStatus;
    dataAvailable = false;
  }

  if (primeId === FREE_ARTICLE_PRIME_ID)
    primeTemplateChunk = 'toipArticleshowv2desktop_prime';

  if (dataAvailable) {
    title = state.articleshow_v2.data[params.msid].seo
      ? state.articleshow_v2.data[params.msid].seo.title
      : '';
    isPrime =
      state.articleshow_v2.data[params.msid].cs &&
      state.articleshow_v2.data[params.msid].cs.toLowerCase() === 'prime';
    if (
      state.articleshow_v2.data[params.msid].filters &&
      state.articleshow_v2.data[params.msid].filters.length > 0
    ) {
      context.store.dispatch(
        getActiveCfmid(state.articleshow_v2.data[params.msid].filters[0].cfmid),
      );
    }
    if (typeof window === 'undefined' && isPrime) {
      await context.store.dispatch(loadLayoutDataTOIP(newParams));
      state = context.store.getState();
    }
    const articleShowData = state.articleshow_v2.data[params.msid];
    const getTopicOrArticleSectionName = articleData => {
      let bundleUrlObj;
      const { metaInfo: { TopicTree } } = articleData;
      if (TopicTree) {
        bundleUrlObj = {
          ...bundleUrlObj,
          topicUrl: TopicTree,
        };
      }
      return bundleUrlObj;
    };
    if (isPrime && primeId) {
      dataPromiseArray.push(context.store.dispatch(getCardData(newParams)));
      const bundleUrlObj = getTopicOrArticleSectionName(articleShowData);
      if (articleShowData && bundleUrlObj) {
        if (bundleUrlObj.topicUrl) {
          dataPromiseArray.push(
            context.store.dispatch(getBundleHashtag(bundleUrlObj.topicUrl)),
          );
        }
      }
    }

    if (isPrimeContent(primeId)) {
      let img;
      let defaultImage = { imagesize: 110164, id: 47529300 };
      if (
        state.articleshow_v2.data[params.msid] &&
        state.articleshow_v2.data[params.msid].images &&
        state.articleshow_v2.data[params.msid].images.length > 0
      ) {
        defaultImage = state.articleshow_v2.data[params.msid]?.images[0];
      }
      const webImage = state.articleshow_v2.data[params.msid]?.images?.find(
        el => el?.payload?.toLowerCase() === 'OverrideLeadImage'.toLowerCase(),
      );
      if (
        state.articleshow_v2?.data[params.msid]?.metaInfo?.Hideheadline === '1'
      ) {
        img = webImage || defaultImage;
      }
      img = webImage || defaultImage;
      if (img) {
        imageInfo.push(
          `https://static.toiimg.com/thumb/width-800,height-450,${
            img?.imagesize ? `imgsize-${img.imagesize}` : ''
          },msid-${img?.id}/${img?.id}.jpg`,
        );
      }
      // imageInfo.push('https://static.toiimg.com/photo/69822060.cms');
      // imageInfo.push('https://static.toiimg.com/photo/89937430.cms');
      // imageInfo.push('https://static.toiimg.com/photo/89633497.cms');
    }

    if (!isPrimeContent(primeId)) {
      const leadImgId =
        articleShowData &&
        articleShowData.images &&
        articleShowData.images.length &&
        articleShowData.images[0] &&
        articleShowData.images[0].id;
      const imageName =
        !isSPOTLIGHTArticle &&
        articleShowData &&
        articleShowData.images &&
        articleShowData.images.length &&
        articleShowData.images[0] &&
        !(articleShowData.videos && articleShowData.videos.length > 0)
          ? getImageName(articleShowData.images[0])
          : '';

      const imgsize =
        articleShowData &&
        articleShowData.images &&
        articleShowData.images.length &&
        articleShowData.images[0] &&
        (articleShowData.images[0].imgsize ||
          articleShowData.images[0].imagesize);

      const height =
        isAutoPublishedArticle && !isSPOTLIGHTArticle ? 'height-225,' : '';
      const resizemode = isAutoPublishedArticle && !isSPOTLIGHTArticle ? 72 : 4;

      leadImageHref = createLeadImageUrl(
        {
          id: leadImgId,
          imagesize: imgsize,
        },
        height,
        resizemode,
        imageName || leadImgId,
      );

      if (leadImgId) {
        imageInfo.push(leadImageHref);
      }
    }
    showPreload = imageInfo instanceof Array && imageInfo.length > 0;
    const { widgets } = articleShowData;
    const widgetsPromiseArray = [];
    if (widgets && widgets.length > 0) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i][typeKey] === 'resulttable' && !context.isInitialRender) {
          widgetsPromiseArray.push(
            context.store.dispatch(loadElections(widgets[i].path, isWapView)),
          );
        } else if (
          widgets[i][typeKey] === 'exitpolltable' &&
          !context.isInitialRender
        ) {
          widgetsPromiseArray.push(
            context.store.dispatch(loadExitPoll(widgets[i].path, isWapView)),
          );
        } else if (widgets[i][typeKey] === 'slider' && widgets[i].wu) {
          if (isBrowser) {
            const url = __PROD__
              ? widgets[i].wu
              : widgets[i].wu.replace(
                  'timesofindia.indiatimes',
                  'toidev.indiatimes',
                );

            widgetsPromiseArray.push(
              context.store.dispatch(loadAsBreifs(url, isWapView)),
            );
          }
        }
      }
    }

    if (articleShowData && articleShowData.metaInfo) {
      const { metaInfo } = articleShowData;
      if (metaInfo && metaInfo.Matchid && metaInfo.Matchid !== '') {
        widgetsPromiseArray.push(
          context.store.dispatch(loadBoardResultData(metaInfo)),
        );
      }
    }

    if (widgetsPromiseArray.length > 0 && isServer) {
      await Promise.all(widgetsPromiseArray);
    }
    if (!isPrimeContent(primeId)) {
      isInstaEmbeds = checkInstaEmbeds();
    }
  }

  // #TODO: Comment below once prime is live
  // if (isPrime) {
  //   status = 404;
  //   dataAvailable = false;
  // }

  if (
    isBrowser &&
    dataAvailable &&
    state.articleshow_v2.data[params.msid].seo
  ) {
    let canonicalUrl = state.articleshow_v2.data[params.msid].seo.canonical;
    if (typeof canonicalUrl === 'string') {
      const businessUsageType =
        state?.articleshow_v2?.data[params.msid]?.metaInfo?.BusinessUsageType;
      const isTOISpecialPage =
        businessUsageType && businessUsageType === 'Special Page';
      if (isTOISpecialPage) {
        canonicalUrl = canonicalUrl.replace('/articleshow/', '/featureshow/');
      }
    }
    if (
      canonicalUrl &&
      canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1 &&
      //window.location.href.indexOf('?') === -1 &&
      state.articleshow_v2.data[params.msid].multipublish !== 1
    ) {
      canonicalUrl = canonicalUrl.split('timesofindia.indiatimes.com');
      const urlInBrowser = window.location.pathname;
      const stgArticleshowURL =
        STAGING_URL_PREFIX2 + canonicalUrl[1].toLowerCase();
      if (
        canonicalUrl[1].toLowerCase() !== urlInBrowser.toLowerCase() &&
        stgArticleshowURL !== urlInBrowser.toLowerCase()
      ) {
        try {
          const searchString = window.location.href.split('?')[1];
          // history.push(canonicalUrl[1]);
          window.location.href = `${canonicalUrl[1]}${
            searchString ? `?${searchString}` : ''
          }`;
        } catch (e) {
          window.location.href = canonicalUrl[1];
        }
      }
    }
  }

  // Server Side redirection for the incorrect URL
  if (
    !isBrowser &&
    dataAvailable &&
    state.articleshow_v2.data[params.msid].seo
  ) {
    const hOverRidelink =
      state?.articleshow_v2?.data[params.msid]?.seo?.hOverRidelink;
    if (hOverRidelink) {
      status = 301;
      redirect = hOverRidelink;
    }
    let canonicalUrl = state.articleshow_v2.data[params.msid].seo.canonical;

    if (typeof canonicalUrl === 'string') {
      const businessUsageType =
        state?.articleshow_v2?.data[params.msid]?.metaInfo?.BusinessUsageType;
      const isTOISpecialPage =
        businessUsageType && businessUsageType === 'Special Page';
      if (isTOISpecialPage) {
        canonicalUrl = canonicalUrl.replace('/articleshow/', '/featureshow/');
      }
    }

    let currentDomain = false;
    if (canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1) {
      currentDomain = 'timesofindia.indiatimes.com';
    } else if (canonicalUrl.indexOf('toidev.indiatimes.com') > -1) {
      currentDomain = 'toidev.indiatimes.com';
    } else if (canonicalUrl.indexOf(REVIEWS_LIVE_DOMAIN_WITHOUT_HTTPS) > -1) {
      currentDomain = REVIEWS_LIVE_DOMAIN_WITHOUT_HTTPS;
    }

    if (
      canonicalUrl &&
      currentDomain &&
      pathname.indexOf('?') === -1 &&
      state.articleshow_v2.data[params.msid].multipublish !== 1
    ) {
      canonicalUrl = canonicalUrl.split(currentDomain);
      const urlPath = pathname;
      const stgArticleshowURL =
        STAGING_URL_PREFIX2 + canonicalUrl[1].toLowerCase();
      if (
        canonicalUrl[1].toLowerCase() !== urlPath.toLowerCase() &&
        stgArticleshowURL !== urlPath.toLowerCase()
      ) {
        let finalQueryString = '';
        if (Object.keys(context.query).length > 0) {
          const queryString = new URLSearchParams();
          Object.keys(context.query).forEach(key =>
            queryString.append(key, context.query[key]),
          );
          finalQueryString = queryString.toString();
          finalQueryString = `?${finalQueryString}`;
        }
        status = 301;
        redirect = `${isReviewsPage ? REVIEWS_LIVE_DOMAIN : TOI_LIVE_DOMAIN}${
          canonicalUrl[1]
        }${finalQueryString}`;
      }
    }
  }

  state = context.store.getState();
  // TODO: Election Widget
  const electionDataPromiseArray = [];
  if (
    dataAvailable &&
    state?.articleshow_v2?.data[params.msid]?.story &&
    Array.isArray(state?.articleshow_v2?.data[params.msid]?.story) &&
    state?.articleshow_v2?.data[params.msid]?.story.length > 0
  ) {
    const electionwdtElements = state?.articleshow_v2?.data[
      params.msid
    ]?.story.find(item => item[typeKey] === 'electionwdt');
    const electionTabs = state.common?.siteConfig?.electionTabs;
    if (
      electionwdtElements &&
      electionTabs &&
      Array.isArray(electionTabs) &&
      electionTabs.length > 0
    ) {
      const assemblyElectionSelection = electionTabs.filter(
        tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
      );
      // const lokSabhaElectionSelection = electionTabs.filter(
      //   tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
      // );

      if (
        assemblyElectionSelection &&
        Array.isArray(assemblyElectionSelection) &&
        assemblyElectionSelection.length > 0 &&
        !state?.electionV2?.refreshinterval
      ) {
        const assemblyElectionUrl =
          state.common?.siteConfig?.assemblyElectionUrl;
        electionDataPromiseArray.push(
          context.store.dispatch(
            loadElectionData(null, assemblyElectionUrl, true),
          ),
        );
      }
      // if (
      //   lokSabhaElectionSelection &&
      //   Array.isArray(lokSabhaElectionSelection) &&
      //   lokSabhaElectionSelection.length > 0 &&
      //   !state?.lokSabhaElection?.refreshinterval
      // ) {
      //   const loksabhaElectionUrl =
      //     state.common?.siteConfig?.loksabhaElectionUrl;
      //   electionDataPromiseArray.push(
      //     context.store.dispatch(
      //       loadLokSabhaElectionData(null, loksabhaElectionUrl, true),
      //     ),
      //   );
      // }
    }
  }
  if (typeof window === 'undefined') {
    await Promise.all(electionDataPromiseArray);
  }
  state = context.store.getState();

  const atfFanAdData = getAtfFanAdCode();
  const footerFanAdData = getFbnFanAdCode();

  const getComponent = async pageTitle => {
    // #TODO: Comment below once prime is live
    // if (isPrime) {
    // return <div>redirecting to TOI</div>;
    // }

    let returnHtml;
    if (dataAvailable) {
      const prebidObj = _get(
        state,
        `common.siteConfig.prebid.templates.articleshow`,
      );
      let articleBlockCap = 0;
      let resetDays = 30;
      const blockCap = _get(
        state,
        `common.siteConfig.articleblockcap.web.count`,
      );
      const blockCapResetDays = _get(
        state,
        `common.siteConfig.articleblockcap.web.resetdays`,
      );
      // eslint-disable-next-line no-restricted-globals
      if (blockCap && !isNaN(parseInt(blockCap, 10))) {
        articleBlockCap = parseInt(blockCap, 10);
      }

      // eslint-disable-next-line no-restricted-globals
      if (blockCapResetDays && !isNaN(parseInt(blockCapResetDays, 10))) {
        resetDays = parseInt(blockCapResetDays, 10);
      }

      context.store.dispatch(updateArticleToShowCount(articleBlockCap));
      context.store.dispatch(updateArticleToShowResetDays(resetDays));
      context.store.dispatch(updatePrebidFlag(prebidObj));
      const categoryForGA = `WEB${isPrime ? '-Prime' : ''}-articleshowv2${
        isMspUSPage ? '_US' : ''
      }`;
      const rhsWidgetPriorityAS = _get(
        state,
        `common.siteConfig.rhsWidgetPriorityAS`,
        {},
      );
      const rhsWidgetVideoAS = _get(
        state,
        `common.siteConfig.rhsWidgetVideoAS.autoPlay`,
        '1',
      );
      const abTestCtnAdsId = _get(
        state,
        `common.siteConfig.abexperiment.ctnAds.experimentid`,
        '',
      );
      const abTestUpNextId = _get(
        state,
        `common.siteConfig.abexperiment.upnextsticky.experimentid`,
        '',
      );
      const forcePollShow = _get(
        state,
        `common.siteConfig.showASPollInsert`,
        '',
      );
      const scrollASHeight = _get(
        state,
        `common.siteConfig.abexperiment.upnextsticky.scrollHeight`,
        '',
      );
      const refreshTime = _get(
        state,
        `common.siteConfig.abexperiment.pagerefresh.refreshminutes.articleshow`,
        0,
      );
      const abAdskey = _get(
        state,
        `common.siteConfig.abexperiment.abAdskey`,
        '',
      );
      const abTestExperimentId = {
        abTestUpNextId,
        abTestCtnAdsId,
      };
      const isAdRemoved =
        isAdRestrictedArticle ||
        params.msid === '92640129' ||
        isMSPArticle ||
        isReviewsPage;
      if (isBrowser) {
        window.categoryForGA = categoryForGA;
        window.categoryForSearchGA = 'WEB-TOI-Articleshow';
        const secName = _get(
          state.articleshow_v2.data[params.msid],
          'navsubsecs.subsec2.subsecname2',
          '',
        );
        setAdsConfig({ subSection: secName.toLowerCase() });
        if (isMspUSPage) {
          const { articleshow_v2: { data = {} } = {} } = state;
          const articleData = data[[params.msid]] || {};
          fireCustomDimension(articleData.mspUSCategory, 'dimension60');
        }
      }
      // #TODO: Uncomment below once prime is live
      // if (isPrime) {
      // const {
      // default: ArticleshowPrime,
      // } = await import(/* webpackChunkName: "articleshowv2desktopprime" */ './ArticleshowPrime');
      // returnHtml = (
      // <LayoutPrime
      // title={pageTitle}
      // params={newParams}
      // query={Object.keys(context.query).length ? context.query : {}}
      // isAppView={isAppView}
      // >
      // <ArticleshowPrime
      // isWapView={isWapView}
      // isAppView={isAppView}
      // msid={newParams.msid}
      // query={Object.keys(context.query).length ? context.query : {}}
      // />
      // </LayoutPrime>
      // );
      // } else {
      const { default: Articleshow } =
        !(!!isPrime && !!primeId) &&
        (await import(/* webpackChunkName: "articleshowv2_desktop_nonprime" */ './Articleshow'));
      const articleShowData = state.articleshow_v2.data[params.msid];
      /* code for SRA ads */
      if (_get(articleShowData, 'ads.dfp.experiment') === 'sra1') {
        newParams.delayTrackerAds = true;
        newParams.lazyloadRhsAds = true;
        newParams.lazyMobileBodyAds = true;
      }
      /* end code for SRA ads */

      const subSecSeoLocation =
        articleShowData.navsubsecs &&
        articleShowData.navsubsecs.subsec1 &&
        articleShowData.navsubsecs.subsec1.seolocation1;
      const isCardCMS =
        _get(articleShowData, `metaInfo.CARDPAGETEMPLATE`) === 'cardhd';
      const electionFlag = _get(state, `common.siteConfig.showelection`);
      const electionInsertFlag = _get(
        state,
        `common.siteConfig.showelectioninsert`,
        false,
      );
      if (isCardCMS) {
        showMiniTv = false;
        hideAdCude = true;
      }
      const jrevWidgets = _get(state, 'revenue.data.widgets', {});
      if (isMSPArticle || isAdRemoved || jrevWidgets?.skipAllWidget) {
        hideAdCude = true;
        showMiniTv = false;
      }
      const topSearches =
        state.commonData && state.commonData?.data?.topSearches;
      const loadPerpetualsInView = isExperimentEnabled(
        state,
        pathname,
        'articleshow',
        'loadPerpetualsInView',
      );

      if (isPrime && primeId) {
        if (typeof window === 'object') {
          setNavDataInGlobalObj(articleShowData.navsubsecs);
        }
        const { default: PrimeShow } =
          state.isPrime || primeId === FREE_ARTICLE_PRIME_ID
            ? await import(/* webpackChunkName: "toipArticleshowv2desktop_prime" */ 'routes/toiplusprimeshow/components/common/PrimeArticleShow')
            : await import(/* webpackChunkName: "toipArticleshowv2desktop_nonprime" */ 'routes/toiplusprimeshow/components/common/PrimeShow');
        const { articleshow_v2: { data = {} } = {} } = state;
        const articleData = data[[params.msid]] || {};
        setGrxParams(articleData, {
          contentType: 'prime_as',
        });
        returnHtml = (
          <Layout
            layoutClass="toipLayout layout_type_2"
            title={pageTitle}
            params={newParams}
            query={Object.keys(context.query).length ? context.query : {}}
            layoutType="primeshow"
            hideStickyBackToTop
            rhs={false}
            hideAdCude
            toipLayout
            storyTitle={storyTitle}
            msid={newParams.msid}
            // #todo - revenue - move this to jarvis
            desktopAdCode={{
              adType: 'dfp',
              tn: 'ad',
              size: [[980, 200], [728, 90]],
              divId: 'div-gpt-ad-1629893944784-0-123456789',
              adCode:
                '/23037861279/TOI_WEB/TOI_WEB_OTHERS/TOI_WEB_OTHERS_AS/TOI_WEB_OTHERS_AS_ATF',
            }}
            templateName={ARTICLESHOW}
            articleData={articleData}
            pageType="toiplusarticleshow"
            isReviewsPage={isReviewsPage}
          >
            <PrimeShow
              isWapView={false}
              msid={newParams.msid}
              location={context.pathname}
              isAppView={isAppView}
              storyTitle={storyTitle}
              query={Object.keys(context.query).length ? context.query : {}}
              isPrime={state?.isPrime}
              itemSubtypeKey={subtypeKey}
              itemTypeKey={typeKey}
              isNewFeedEnabled={isNewFeedEnabled}
            />
          </Layout>
        );
      } else {
        returnHtml = (
          <Layout
            layoutClass="layout_type_2"
            title={pageTitle}
            params={newParams}
            query={Object.keys(context.query).length ? context.query : {}}
            layoutType=""
            hideStickyBackToTop
            rhs={false}
            adPosition="masthead"
            showMiniTv={showMiniTv}
            showAdBlockerInINEU
            // hideAdBlockerDetector //comment this to add adblocker
            refreshFBNAd
            adsCampaignStatusUrl={_get(
              state.articleshow_v2.data[params.msid],
              `ads.dfp.info.MANAGE_AD_URL`,
            )}
            hideBreadcrumAtBottom
            hideTimesPointPopup={isCardCMS}
            hideAdCude={hideAdCude}
            pageType="ARTICLESHOW"
            subSecSeoLocation={subSecSeoLocation}
            atfFanAdData={atfFanAdData}
            footerFanAdData={footerFanAdData}
            customclasslayoutwrapper={isCardCMS ? s.fullwidth : ''}
            hideAds={isReviewsPage || isCardCMS || isMSPArticle || isAdRemoved}
            // gutterAdCode={_get(
            //   state.articleshow_v2.data[params.msid],
            //   `ads.dfp.slots.OOP1`,
            // )}
            gutterAdCode={_get(
              state,
              'revenue.data.ads.layout.gutter',
              undefined,
            )}
            showCovid19PopUp
            disablePopUpManager
            msid={newParams.msid}
            hideSubscribeAndMediaLink={isReviewsPage}
            // showTopSearchAtTop={
            //   !isCardCMS &&
            //   topSearches &&
            //   topSearches.items &&
            //   topSearches.items.length
            // }
            isAffiliatePage={isMSPArticle}
            disableTimesPointWidget={isMSPArticle}
            skipAds={
              isAdRestrictedArticle ||
              params.msid === '92640129' ||
              isMSPArticle
            }
            hideAffiliatesFloatingNudge
            enableCityChangeFeature
            templateName={ARTICLESHOW}
            isReviewsPage={isReviewsPage}
          >
            {/* <WithMiniTv /> */}
            {/* <WithNewsInContext
              isWapView={isWapView}
              isTablet={isTablet}
              isIOS={isIOS}
            /> */}
            {!isMSPArticle && <WithVideoTheater isWapView={isWapView} />}
            {/* {!isTablet() &&
 state.articleshow_v2.data[params.msid] && (
 <AdCaller
 className="gutterAd"
 fallbackAd={{
 ..._get(
 state.articleshow_v2.data[params.msid],
 `ads.dfp.slots.STICKY`,
 {},
 ),
 }}
 data={{
 ..._get(
 state.articleshow_v2.data[params.msid],
 `ads.dfp.slots.OOP1`,
 {},
 ),
 },
 }}
 />
 )} */}
            <Articleshow
              isWapView={isWapView}
              isAppView={isAppView}
              msid={newParams.msid}
              query={Object.keys(context.query).length ? context.query : {}}
              //isMiniView={isArticleshowMini}
              //RHS={RHSArticle}
              preloadedLeadImageHref={leadImageHref || ''}
              isReviewsPage={isReviewsPage}
              isMspArticle={isMSPArticle}
              isMspUSPage={isMspUSPage}
              isAdRemoved={isAdRemoved}
              params={newParams}
              isCardCMS={isCardCMS}
              electionFlag={electionFlag === '1'}
              electionInsertFlag={electionInsertFlag === '1'}
              categoryForGA={categoryForGA}
              // enableNextArticleStickyPopUp={isWorldArticle || isCityArticle}
              abTestExperimentId={abTestExperimentId}
              abAdskey={abAdskey}
              refreshTime={parseFloat(refreshTime, 10)}
              forcePollShow={forcePollShow}
              scrollASHeight={scrollASHeight}
              rhsWidgetPriorityAS={rhsWidgetPriorityAS}
              rhsWidgetVideoAS={!!rhsWidgetVideoAS === '1'}
              location={context.pathname}
              topSearches={topSearches}
              isSPOTLIGHTArticle={isSPOTLIGHTArticle}
              spotlightSpecificAds={spotlightSpecificAds}
              isAutoPublishedArticle={isAutoPublishedArticle}
              isSportsBeaconJs={isSportsBeaconJs}
              // isPixelPlaylistID={beaconPlaylistID}
              isCityArticle={isCityArticle}
              loadPerpetualsInView={loadPerpetualsInView}
              itemSubtypeKey={subtypeKey}
              itemTypeKey={typeKey}
              isNewFeedEnabled={isNewFeedEnabled}
            />
            {/* {!isCardCMS &&
              topSearches &&
              topSearches.items &&
              topSearches.items.length > 0 && (
                <div
                  className={`${s.topsearches} ${s.topsearches_top} ${
                    state.isPrime ? s.topSearches_prime : ''
                  }`}
                  id="articlshow-topSearch"
                >
                  <div className="contentwrapper">
                    <LinksList
                      sectionData={{
                        ...topSearches,
                        data: [...topSearches.items],
                      }}
                      cssSelector="astrendinglist"
                      gaCategory={categoryForGA}
                      gaAction="click"
                      gaLabel="topSearches"
                    />
                  </div>
                </div>
              )} */}
          </Layout>
        );
      }
      return returnHtml;
    }
    return (
      <div>
        Something went wrong. Click{' '}
        <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
      </div>
    );
  };

  const getMaxAge = () => {
    let maxAge = setCacheTime(state && state.isPrime);
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].maxAge
    ) {
      maxAge = state.articleshow_v2.data[params.msid].maxAge;
    }

    return maxAge;
  };

  const getEpaperLocation = () => {
    if (
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].metaInfo
    ) {
      return state.articleshow_v2.data[params.msid].metaInfo?.eploc || '';
    }
    return '';
  };

  const getHrefLang = () => {
    const hreflang = [];
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    if (isMSPArticle) {
      const { mspHrefLangUrl = {} } = articleData;
      if (mspCountryCode) {
        getMspBasicPageHrefLang(context, hreflang, mspCountryCode);
      } else if (isMspUSPage) {
        getMspUSPageHrefLang(context, hreflang, mspHrefLangUrl);
      } else {
        getMspInPageHrefLang(context, hreflang, mspHrefLangUrl);
      }
    }
    return hreflang;
  };

  const getSeoData = async () => {
    const seoObj =
      state.articleshow_v2 && state.articleshow_v2.data
        ? _get(state.articleshow_v2.data[params.msid], 'seo', {})
        : {};

    let schemaObj =
      state.articleshow_v2 && state.articleshow_v2.data
        ? _get(state.articleshow_v2.data[params.msid], 'schema', [])
        : [];
    if (isNewFeedEnabled) {
      schemaObj =
        state.articleshow_v2 &&
        state.articleshow_v2.data &&
        state.articleshow_v2.data[params.msid]
          ? generateArticleshowSchema(
              state.articleshow_v2.data[params.msid],
              seoObj,
              newParams,
            )
          : [];
    }

    if (schemaObj && schemaObj.length > 0) {
      seoObj.schema = schemaObj;
    }
    if (isReviewsPage) {
      const currentSectionConfig = reviewsSectionList.find(section => {
        const { sectionName } = section || {};
        return context.pathname.startsWith(`/${sectionName}`);
      });
      const { isNoFollowNoIndex } = currentSectionConfig || {};
      seoObj.noindexnofollow = isNoFollowNoIndex === 'true';
      seoObj['google-site-verification'] = REVIEWS_SITE_VERIFICATION_CODE;
    }
    seoObj.ogType = 'article';
    seoObj.article = true;
    // AF-1106 disabling this function fow now
    seoObj.hreflang = getHrefLang();
    //seoObj.hreflang = [];
    const agencyName =
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].ag;
    seoObj.agencyName = agencyName;

    const categorytags =
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].metaInfo?.categorytags;

    if (isNewFeedEnabled) {
      const sponsoredContentMeta =
        state.articleshow_v2 && state.articleshow_v2.data
          ? _get(
              state.articleshow_v2.data[params.msid],
              'metaInfo.BusinessRuleSponsoredContent',
              '',
            )
          : '';
      if (sponsoredContentMeta) {
        seoObj.sponsoredContentMeta = sponsoredContentMeta;
      }
    }

    if (
      (agencyName === 'Mediawire' ||
        agencyName === 'SPOTLIGHT' ||
        agencyName === 'Spotlight Wire') &&
      categorytags !== 'Editorial Checked Spotlight'
    ) {
      seoObj.noindexnofollow = true;
    }
    return seoObj;
  };

  const checkCoronaForSEO = data => {
    if (
      data &&
      data.title &&
      data.keywords &&
      (data.title.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
        data.title.toLocaleLowerCase().indexOf('covid') > -1 ||
        data.keywords.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
        data.keywords.toLocaleLowerCase().indexOf('covid') > -1)
    ) {
      return true;
    }
    return false;
  };
  const isMultipublish = () => {
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].multipublish
    ) {
      return true;
    }

    return false;
  };

  const getCategoryTabsMeta = () => {
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].story
    ) {
      const categoryNode = state.articleshow_v2.data[params.msid].story.filter(
        stry => stry[typeKey] === 'pollwidget',
      );
      return categoryNode &&
        Array.isArray(categoryNode) &&
        categoryNode.length > 0
        ? categoryNode[0]?.categorytabs
        : 'N/A';
    }

    return 'N/A';
  };

  const getGAConfig = async () => {
    let gaData = {};

    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid]
    ) {
      gaData = getGAData(state.articleshow_v2.data[params.msid]);
    }
    const sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation && state.navigation.breadCrumbs
        ? state.navigation.breadCrumbs
        : [],
    );
    gaData.dimension8 = getCustomDimension8(sectionsNameList);
    if (isPrime && isPrimeContent(primeId)) {
      if (primeId === PAID_ARTICLE_PRIME_ID) {
        gaData.dimension9 = TEMPLATE_NAME_FOR_TOIP_PAID_ARTCILE;
      } else if (primeId === FREE_ARTICLE_PRIME_ID) {
        gaData.dimension9 = TEMPLATE_NAME_FOR_TOIP_FREE_ARTCILE;
      }
      const sectionValues = Object.values(
        state.articleshow_v2.data[params.msid].navsubsecs,
      );
      const section =
        Array.isArray(sectionValues) && sectionValues.length > 0
          ? sectionValues[sectionValues.length - 1]
          : null;
      gaData.dimension8 =
        section?.subsecname3 || section?.subsecname2 || section?.subsecname1;
    }
    const isCovidRelated =
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].isCovid19Story;
    const coronaTextInSEOFeed =
      !isCovidRelated &&
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].seo &&
      checkCoronaForSEO(state.articleshow_v2.data[params.msid].seo);
    if (isCovidRelated || coronaTextInSEOFeed) {
      gaData.dimension23 = 'Covid-19';
    }
    const isAutoIngested =
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].metaInfo &&
      state.articleshow_v2.data[params.msid].metaInfo.AutoFeedIngestion;
    if (isAutoIngested === '1.0') {
      gaData.dimension27 = 'Auto Injested';
    }
    return gaData;
  };

  let adsTargetingObj = {};
  let skipInterstitial = false;
  const layoutdata =
    state?.articleshow_v2?.data &&
    params?.msid &&
    state.articleshow_v2.data[params.msid];
  if (layoutdata) {
    const authorsData = _get(layoutdata, 'authors', []);
    const authorsName = getAuthorsName(authorsData);
    const templateConfig = {
      Tmpl_SCN: 'Articleshow',
      Channel: 'toi',
      isMobile: state.isMobile,
      pathname,
      articleId: params.msid,
      newkws: _get(layoutdata, 'newsKws', ''),
      kws: _get(layoutdata, 'seo.keywords', ''),
      specialId: _get(layoutdata, 'metaInfo.SpecialID'),
      navSubsecs: _get(layoutdata, 'navsubsecs', {}),
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      dl: _get(layoutdata, 'dl', ''),
      contentType: _get(layoutdata, 'metaInfo.Contenttype'),
    };
    const hypVals = _get(
      state,
      'common.siteConfig.revenue.revenue_section.hyp1Vals',
      [],
    );

    if (hypVals.includes(templateConfig.specialId)) {
      showMiniTv = false;
      hideAdCude = true;
      skipInterstitial = true;
    }
    const { keyValueObj, newCaimpaignConfig } = processAdsCaimpaigns(
      templateConfig,
    );
    const feedkeys = _get(layoutdata, 'adstargetkeyVals', {});
    adsTargetingObj = {
      author: authorsName,
      ...feedkeys,
      ...keyValueObj,
    };
    if (!isPrime && typeof window === 'undefined' && status === 200) {
      // Revenue Active or not
      context.store.dispatch(updateCaimpaignAdsConfig(newCaimpaignConfig));
      // Page Ads call
      await context.store.dispatch(loadPageAdCode(templateConfig));
      state = context.store.getState();
    }
  }

  if (isBrowser) {
    setValue({
      isAppView,
      isWapView,
      artData:
        state &&
        state.articleshow_v2 &&
        state.articleshow_v2.data &&
        state.articleshow_v2.data[params.msid],
      msid: params.msid,
    });
  }
  const gtmIDForOptimisely = isPrimeContent(primeId)
    ? ['GTM-KCRX3PN', 'OPT-MZ46ZWC']
    : ['GTM-54ZCD8R', 'OPT-MZ46ZWC'];
  if (
    typeof window !== 'undefined' &&
    !isPrimeContent(primeId) &&
    !isExperimentEnabled(state, pathname, 'articleshow', 'optimiseGA4PageView')
  ) {
    const categorytabsmeta = getCategoryTabsMeta();
    fireGA4Script({
      vmsid: params.msid,
      categorytabsmetainfo: categorytabsmeta,
    });
  }
  const isAdRemoved =
    isAdRestrictedArticle ||
    params.msid === '92640129' ||
    isMSPArticle ||
    isReviewsPage;
  // experiment variables
  const skipSections = ['astrology'];
  const skipBidsExperiment = skipSections.includes(adsTargetingObj?.SCN);
  // end experiment variables

  const afterAdsScript = [];
  if (isInstaEmbeds || context?.query?.incInstaEmbd) {
    afterAdsScript.push(TOI_INSTAGRAM_EMBED_JS);
  }
  const articleShowData =
    state &&
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid];
  if (articleShowData) {
    const { metaInfo } = articleShowData;
    const isBoardResultData =
      state && state.articleshow_v2 && state.articleshow_v2.boardresultdata;
    if (
      isBoardResultData &&
      metaInfo &&
      metaInfo.Matchid &&
      metaInfo.Matchid !== ''
    ) {
      afterAdsScript.push(
        `${TOI_LIVE_DOMAIN}/html_to_pdf/minify-1,version-1.cms`,
        `${TOI_LIVE_DOMAIN}/jspdf/minify-1,version-1.cms`,
      );
    }
  }

  const noAdArticle = state.isPrime || isMSPArticle || isAdRemoved;
  let sSjConf = null;

  if (!noAdArticle && !skipInterstitial) {
    const webInterstitial = {
      cookExpireInhours: 1,
      skipInitialCall: true,
    };
    sSjConf = { webInterstitial };
  }
  const revWidgets = _get(state, 'revenue.data.widgets', {});

  let skipRouteAds = false;
  if (!spotlightSpecificAds) {
    skipRouteAds = state.isPrime || isMSPArticle || isAdRemoved;
  }

  if (!isReviewsPage && redirectableReviewSection) {
    if (isBrowser) {
      window.location.href = getReviewsPageURLFromMspPageURL(
        redirectableReviewSection,
        pathname,
      );
    } else {
      redirect = getReviewsPageURLFromMspPageURL(
        redirectableReviewSection,
        pathname,
      );
      status = 301;
    }
  }
  let cwvReportingInfo = {};

  try {
    cwvReportingInfo = getCwvReportingObj({
      dataAvailable,
      state,
      platform: DESKTOP_PLATFORM,
      browsingPlatform: isAppView ? WEBVIEW_PLATFORM : DESKTOP_PLATFORM,
      businessProperty: BUSINESS_TOI,
      pageName: 'articleshow',
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('issue in cwvReportingInfo');
    cwvReportingInfo = {};
  }

  return {
    chunks: [
      pageName,
      !(!!isPrime && !!primeId)
        ? 'articleshowv2_desktop_nonprime'
        : primeTemplateChunk,

      // isPrime ? 'articleshowv2desktopprime' : 'articleshowv2_desktop_nonprime',
    ],
    title,
    seoData: await getSeoData(),
    maxAge: getMaxAge(),
    gaData: await getGAConfig(),
    status,
    component: await getComponent(title),
    adsTargetingObj,
    multipublish: isMultipublish(),
    isMaxImagePreview: true,
    isMaxVideoPreview: false,
    shiftGutter: true,
    skipGpt: !isWapView,
    skipRouteAds,
    removeThirdParty: isAdRemoved && !isMSPArticle && !isSPOTLIGHTArticle,
    addPersonaliseLib: true,
    // no ad scripts are required on msp articles, common commonHeadScripts and commonHeadScriptsMobile contain
    // only add related scripts as on 17 dec 2021
    // please update this check, if non ad related scripts are added too commonHeadScripts and commonHeadScriptsMobile
    // eslint-disable-next-line no-nested-ternary
    headTags:
      // eslint-disable-next-line no-nested-ternary
      isMSPArticle
        ? [<script id={AFFILIATES_SDK_URL} src={AFFILIATES_SDK_URL} async />]
        : // eslint-disable-next-line no-nested-ternary
          isAdRemoved || isPrimeContent(primeId)
          ? [
              ...commonHeadScripts,
              <script
                dangerouslySetInnerHTML={{
                  __html: implementExperiment(),
                }}
              />,
            ]
          : isWapView
            ? [...commonHeadScriptsMobile]
            : [
                ...commonHeadScripts,
                <script
                  dangerouslySetInnerHTML={{
                    __html: gptHeadAppendScript,
                  }}
                />,
                <script
                  dangerouslySetInnerHTML={{
                    __html: adRecoverScriptString,
                  }}
                />,
                <script
                  dangerouslySetInnerHTML={{
                    __html: implementExperiment(),
                  }}
                />,
              ],
    skipPageViewGAOnLoad: true,
    gtmIDList: gtmIDForOptimisely,
    isPerfExperimented: !state.isPrime,
    useVariableFonts: !state.isPrime || isPrimeContent(primeId),
    inlineFirstFoldCSS: !state.isPrime || isPrimeContent(primeId),
    TOIPlusRoute: isPrimeContent(primeId),
    isAffiliatePage: isMSPArticle,
    showPreload,
    imageInfo,
    redirect,
    showAdsOnTOIP: !state.isPrime && isPrimeContent(primeId),
    staticGpt: skipBidsExperiment,
    skipPwt: skipBidsExperiment,
    edgeCacheTag: params.msid,
    eploc: getEpaperLocation() || '',
    xFrameOptions: true,
    afterAdsScript,
    routePreloads: skipBidsExperiment
      ? [
          {
            rel: 'preload',
            as: 'script',
            href: TAM_SCRIPT,
            fetchPriority: 'high',
          },
        ]
      : [],
    skipColumbiaScript: _get(revWidgets, 'skipCTN', false),
    enableInterstitial: !!sSjConf,
    jarvisAdsConfig: sSjConf,
    coreWebVitalPage: 'webvital_old_v1',
    isSportsBeaconJs,
    preventUserActionOnNIElements: true,
    addDebugBearScript: false,
    debugBearScript: null,
    extractAppState: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'extractAppState',
    ),
    enableContentSecurity: isCityArticle,
    cwvReportingInfo,
    optimiseGA4PageView: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'optimiseGA4PageView',
    ),
    ga4PageViewParams: getGa4PageViewEventObj(
      dataAvailable || {},
      {
        pageTemplate: 'articleshow',
        isMobile: state.isMobile,
        isPrime: state.isPrime,
        pagination: 'p0',
        perpetual: true,
        categorytabsmetainfo: getCategoryTabsMeta(),
        path: context.pathname,
      },
      state.isPrime ? { subs_experience_type: 'NEW_v1.3.0' } : {},
    ),
    loadResourcesOnBrowserIdle: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'loadResourcesOnBrowserIdle',
    ),
  };
}

export default action;
